import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ResolvableServiceUsagesGroupForm_ResolvableServiceUsagesGroup_Fragment =
  graphql(`
    fragment ResolvableServiceUsagesGroupForm_ResolvableServiceUsagesGroup_Fragment on ResolvableServiceUsagesGroup {
      _id
      groupingMode
      index
      isOptional
      label
      manualTotal {
        ...ManualTotalForm_ResolvableServiceValue_Fragment
      }
      totalMode
      serviceUsages {
        ...ResolvableServiceUsageForm_ResolvableServiceUsage_Fragment
        ...ServiceUsageCardCmp_ResolvableServiceUsage_Fragment
      }
    }
  `);

export type ResolvableServiceUsagesGroupForm_ResolvableServiceUsagesGroup =
  ResultOf<
    typeof ResolvableServiceUsagesGroupForm_ResolvableServiceUsagesGroup_Fragment
  >;
